/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { styled } from '@mui/system';
import { Box, Typography, Container } from '@mui/material';

const FooterWrapper = styled(Box, {})(({ theme }) => ({
  width: 'calc(100% - 250px)',
  backgroundColor: theme.palette.green.main,
  color: '#FFFFFF',
  zIndex: 10,
  padding: '10px 0',
  marginLeft: '250px',
  textAlign: 'center',
  p: {
    color: '#FFFFFF',
  },
  a: {
    color: '#FFFFFF',
  },
  img: {
    width: '112px',
    height: 'auto',
    marginTop: '10px',
  },
}));

const Footer = () => (
  <FooterWrapper>
    <Container maxWidth="xl">
      <Typography variant="body1">
        Benefit from specialist advice on SAP data integration and analytics, by visiting:
        {' '}
        <a href="https://www.qlik.com/us/products/technology/sap" target="_blank" rel="noreferrer">www.qlik.com/sap</a>
      </Typography>
      <img src="assets/images/Qlik-Logo_WHITE.png" alt="Qlik logo" />
    </Container>
  </FooterWrapper>
);

export default Footer;
